import React from 'react';
import { Badge } from '@components/atoms/Badge';
import { SubcontractorHealth } from '@models/subcontractor.model';
import { useTranslation } from '@hooks/useTranslation';

interface HealthPillProps {
  health: SubcontractorHealth;
  size?: 'sm' | 'md';
}

const VARIANT_BY_HEALTH: Record<SubcontractorHealth, 'success' | 'warning' | 'error' | 'secondary' | 'default'> = {
  [SubcontractorHealth.ON_TRACK]: 'success',
  [SubcontractorHealth.BEHIND]: 'error',
  [SubcontractorHealth.NOT_STARTED]: 'secondary',
  [SubcontractorHealth.COMPLETE]: 'success',
  [SubcontractorHealth.NONE]: 'default',
};

export const HealthPill: React.FC<HealthPillProps> = ({ health, size = 'sm' }) => {
  const tSub = useTranslation('subcontractors');
  const labelByHealth: Record<SubcontractorHealth, string> = {
    [SubcontractorHealth.ON_TRACK]: tSub?.healthOnTrack || 'On track',
    [SubcontractorHealth.BEHIND]: tSub?.healthBehind || 'Behind',
    [SubcontractorHealth.NOT_STARTED]: tSub?.healthNotStarted || 'Not started',
    [SubcontractorHealth.COMPLETE]: tSub?.healthComplete || 'All complete',
    [SubcontractorHealth.NONE]: tSub?.healthNone || 'Nothing delegated',
  };

  return (
    <Badge size={size} variant={VARIANT_BY_HEALTH[health]}>
      {labelByHealth[health]}
    </Badge>
  );
};

export default HealthPill;
